import { render, staticRenderFns } from "./AgendaAppuntamentiStatiEditComponent.vue?vue&type=template&id=f7dd1b7e"
import script from "./AgendaAppuntamentiStatiEditComponent.vue?vue&type=script&lang=js"
export * from "./AgendaAppuntamentiStatiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports